import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

interface IItem {
  CountryCode: string
  Fmt: string | null
  IsRequired: number
  Type: string | null
}

interface IParams {
  countryCode: string
  field: string
}

export const fetchValidationInfoByCountry = ({ countryCode, field }: IParams) => {
  const validationRuleSource = CrudStore.get<IItem>(
    CrudStoreItem.ValidationRules,
    `countryRules-${countryCode}`
  )

  const filterByCountryName = {
    field: 'CountryCode',
    operator: Operator.EQUAL,
    value: countryCode,
  }

  validationRuleSource.setFilter({
    logic: Logic.AND,
    filters: [filterByCountryName],
  })

  return validationRuleSource.fetch().then(({ items }: { items: IItem[] }) => {
    const fieldItems = items?.filter((item) => item.Type?.toUpperCase() === field.toUpperCase())
    const formattedItems = fieldItems?.filter((item): item is IItem & { Fmt: string } =>
      Boolean(item.Fmt?.trim())
    )

    const validateFn = (value: string) => {
      if (!formattedItems) {
        return ''
      }

      let result = ''
      for (const item of formattedItems) {
        const regexp = RegExp(`^${item.Fmt}$`)
        if ((item.IsRequired || value.length) && !regexp.test(value)) {
          result = result.length ? `${result} or ${item.Fmt}` : item.Fmt
        } else {
          result = ''
          break
        }
      }

      if (result) {
        return `The field ${field} has an incorrect value. Use next format: ${result}`
      }
      return result
    }

    return {
      validateFn,
      isRequired: Boolean(fieldItems?.some((item) => item.IsRequired)),
      /**
       * У страны вообще есть правило по этому полю (форма 424).
       *
       * Отличается от `isRequired`: строка может существовать с `IsRequired: 0` — так, например,
       * размечено Пуэрто-Рико для типа STATE. Нужно там, где само наличие правила решает, показывать
       * ли поле, а `IsRequired` — только обязательность.
       */
      hasRule: Boolean(fieldItems?.length),
    }
  })
}
